import { jsxs as n, jsx as d } from "react/jsx-runtime";
import { forwardRef as b, useCallback as u } from "react";
import o from "./styles.module.less.js";
const y = b(
  (a, m) => {
    var l;
    const {
      value: e,
      disabled: r,
      onChange: t,
      getTranslation: s,
      yesLabel: N,
      noLabel: f,
      error: c
    } = a, i = u((p) => ($) => {
      $.preventDefault(), r || t(p);
    }, [r, t]);
    return /* @__PURE__ */ n(
      "div",
      {
        ref: m,
        ...a.props,
        className: `${o.yesNoInput} ${r ? o.disabled : ""} ${(l = a.props) == null ? void 0 : l.className}`,
        children: [
          /* @__PURE__ */ n(
            "button",
            {
              className: `${o.actionButton} ${(e == null ? void 0 : e.toLocaleLowerCase()) === "yes" ? o.active : ""} ${c ? o.error : ""}`,
              onClick: i("yes"),
              disabled: r,
              children: [
                /* @__PURE__ */ d("div", { className: o.dot }),
                N ?? (s == null ? void 0 : s("confirm.yes"))
              ]
            }
          ),
          /* @__PURE__ */ n(
            "button",
            {
              className: `${o.actionButton} ${(e == null ? void 0 : e.toLocaleLowerCase()) === "no" ? o.active : ""} ${c ? o.error : ""}`,
              onClick: i("no"),
              disabled: r,
              children: [
                /* @__PURE__ */ d("div", { className: o.dot }),
                f ?? (s == null ? void 0 : s("confirm.no"))
              ]
            }
          )
        ]
      }
    );
  }
);
y.displayName = "YesNoInput";
export {
  y as YesNoInput
};
